import { library, dom } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

// Brands
import { faFacebookF, faXTwitter, faInstagram } from '@fortawesome/free-brands-svg-icons'

// Solid
import { faSpinner } from '@fortawesome/pro-solid-svg-icons'

// Regular
import { faChevronDown, faCalendar, faClock } from '@fortawesome/pro-regular-svg-icons'

// Light
import { faUser, faPlane } from '@fortawesome/pro-light-svg-icons'

// Sharp Regular
import { faPlus, faMinus } from '@fortawesome/sharp-regular-svg-icons'

// Icon Library
library.add( faFacebookF, faXTwitter, faInstagram, faPlus, faMinus, faChevronDown, faCalendar, faClock, faUser, faPlane, faSpinner )

dom.watch()

export default FontAwesomeIcon